import React, { useState } from "react";
import {
  TextField,
  Button,
  Paper,
  Typography,
  Link,
  createTheme,
  ThemeProvider,
  CssBaseline,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import logo from "../../images/logosegnew.svg";

// Create a dark theme
const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#6fd943",
    },
    background: {
      default: "#121212",
      paper: "#1e1e1e",
    },
    text: {
      primary: "#ffffff",
      secondary: "#aaaaaa",
    },
  },
  typography: {
    fontFamily: "Cairo, sans-serif",
    fontWeight: "500",
  },
});

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleHRLogin = async () => {
    try {
      const response = await axios.post(
        "https://backenderpforseg.samielmetwali.com/HrOrNotLogin.php",
        {
          username,
          password,
        }
      );

      if (response.data.success) {
        localStorage.setItem("authToken", response.data.token);

        localStorage.setItem("data", JSON.stringify(response.data.user)); // Store user data

        navigate("/hr-dashboard"); // أو أي صفحة مناسبة
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      console.error("Error during authentication:", error);
      alert("An error occurred during login. Please try again.");
    }
  };

  const handleEmployeeLogin = async () => {
    try {
      const response = await axios.post(
        "https://backenderpforseg.samielmetwali.com/employeeLogin.php",
        {
          username,
          password,
        }
      );

      if (response.data.success) {
        sessionStorage.setItem("authTokenEmployee", response.data.token); // Store the token
        // Redirect to dashboard with username as hidden state
        localStorage.setItem("data", JSON.stringify(response.data.user)); // Store user data

        navigate("/employee-dashboard", { state: { username: username } });
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      alert("An error occurred during login. Please try again.");
    }
  };

  const containerStyle = {
    height: "100vh",
    display: "flex",
    flexDirection: "row",
    position: "relative",
    overflow: "hidden",
  };

  const whiteDivStyle = {
    flex: 1,
    backgroundColor: "#121212", // Dark background
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
  };

  const greenDivStyle = {
    flex: 1,
    backgroundColor: "#6fd943",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
  };

  const formContainerStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  };

  const paperStyle = {
    padding: "40px 20px",
    width: "400px",
    textAlign: "center",
    borderRadius: "20px",
    backgroundColor: darkTheme.palette.background.paper,
  };

  const textFieldStyle = {
    margin: "10px 0",
    "& .MuiOutlinedInput-root": {
      color: darkTheme.palette.text.primary,
    },
  };

  const buttonStyle = {
    marginTop: "20px",
    backgroundColor: darkTheme.palette.primary.main,
    color: darkTheme.palette.text.primary,
    fontFamily: "Cairo,sans-serif",
    fontWeight: "700",
    fontSize: "18px",
  };

  const rtlContainerStyle = {
    direction: "rtl",
    textAlign: "right",
    width: "100%",
  };

  const linkStyle = {
    fontFamily: "Cairo,sans-serif",
    fontWeight: "500",
    color: darkTheme.palette.primary.main,
    cursor: "pointer",
    textDecoration: "none",
  };

  const secondaryButtonStyle = {
    marginTop: "10px",
    backgroundColor: "#5c636a",
    color: "#fff",
    fontFamily: "Cairo,sans-serif",
    fontWeight: "700",
    fontSize: "16px",
    flex: "1",
    margin: "5px",
  };

  const buttonContainerStyle = {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "20px",
  };

  const imageStyle = {
    position: "absolute",
    bottom: 0,
    width: "50%",
    objectFit: "cover",
  };

  const logoStyle = {
    marginBottom: "50px",
    width: "300px",
  };

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <div style={containerStyle}>
        <div style={formContainerStyle}>
          <img src={logo} alt="Logo" style={logoStyle} />
          <Paper elevation={10} style={paperStyle}>
            <div style={rtlContainerStyle}>
              <Typography
                style={{ fontFamily: "Cairo,sans-serif", fontWeight: "500" }}
                variant="h4"
                component="h4"
                gutterBottom
              >
                بدء الاتصال
              </Typography>
              <Typography
                style={{ fontFamily: "Cairo,sans-serif", fontWeight: "500" }}
                variant="body1"
                component="label"
                gutterBottom
              >
                اسم المستخدم
              </Typography>
              <TextField
                variant="outlined"
                fullWidth
                style={textFieldStyle}
                inputProps={{
                  style: {
                    direction: "rtl",
                    textAlign: "right",
                    color: darkTheme.palette.text.primary,
                  },
                }}
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
              <Typography
                style={{ fontFamily: "Cairo,sans-serif", fontWeight: "500" }}
                variant="body1"
                component="label"
                gutterBottom
              >
                كلمة المرور
              </Typography>
              <TextField
                variant="outlined"
                type="password"
                fullWidth
                style={textFieldStyle}
                inputProps={{
                  style: {
                    direction: "rtl",
                    textAlign: "right",
                    color: darkTheme.palette.text.primary,
                  },
                }}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <Button
                variant="contained"
                fullWidth
                style={buttonStyle}
                onClick={handleHRLogin}
              >
                تسجيل الدخول
              </Button>
              <div style={buttonContainerStyle}>
                <Button
                  variant="contained"
                  style={secondaryButtonStyle}
                  onClick={handleEmployeeLogin}
                >
                  دخول الموظف
                </Button>
                <Button
                  variant="contained"
                  style={secondaryButtonStyle}
                  onClick={handleHRLogin}
                >
                  دخول الموارد البشرية
                </Button>
              </div>
              <div style={buttonContainerStyle}></div>
            </div>
          </Paper>
        </div>
      </div>
    </ThemeProvider>
  );
};

export default Login;
